export default __webpack_public_path__ + "static/task-panel-649c16b774c3fe51af25b9c4c36d072a.mp4";